import axios from 'axios';

import {
  CONFIRMED, DEATHS, GLOBAL_TIME_SERIES_DATA_API_URL, DARK_GRAY, GREEN, RECOVERED, RED,
} from '../constants';

export default async function getGlobalTimeSeries() {
  try {
    const response = await axios(GLOBAL_TIME_SERIES_DATA_API_URL);
    const datasets = Object.entries(response.data);
    const formattedDatasets = datasets.map((dataset) => {
      let label = [RECOVERED, DEATHS].find((item) => item.toLocaleLowerCase() === dataset[0]);
      if (label === undefined) label = CONFIRMED;
      let borderColor;
      if (label === RECOVERED) borderColor = GREEN;
      if (label === CONFIRMED) borderColor = RED;
      if (label === DEATHS) borderColor = DARK_GRAY;
      const data = Object.values(dataset[1]);
      return {
        label,
        data,
        fill: false,
        borderColor,
        pointRadius: 1,
      };
    });
    const labels = Object.keys(datasets[0][1]);
    return {
      labels,
      datasets: formattedDatasets,
      responsive: true,
      maintainAspectRatio: false,
      displayColors: true,
      layout: {
        padding: {
          top: 0,
          left: 15,
          right: 15,
          bottom: 15,
        },
      },
    };
  } catch (error) {
    console.log(`Failed to fetch global time series: ${error.message}`, error);
    return new Error(error);
  }
}
